import React, { useState } from "react";
import { PACKS, fmt, RESALE_FACTOR } from "@/data/packs";
import { SectionHeading } from "@/components/PackSelection";
import { useCart } from "@/context/CartContext";

export const SalesPotential = () => {
  const { addItem } = useCart();
  const [active, setActive] = useState("pack_300");
  const pack = PACKS.find((p) => p.id === active);
  const potential = Math.round(pack.price * RESALE_FACTOR);

  return (
    <section id="potentiel" className="bg-[var(--oz-dark)] text-white scroll-mt-20">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 md:py-24">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-[var(--oz-gold)] mb-4">
            Potentiel de vente
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl font-medium tracking-tight text-white">
            Quel est votre potentiel ?
          </h2>
          <p className="mt-4 text-base text-white/70 leading-relaxed">
            Votre potentiel dépend notamment du nombre de produits vendus, de vos prix de revente,
            de votre clientèle et de votre implication.
          </p>
        </div>

        <div className="flex justify-center gap-2 sm:gap-3 mb-10">
          {PACKS.map((p) => (
            <button
              key={p.id}
              data-testid={`potential-tab-${p.id}`}
              onClick={() => setActive(p.id)}
              className={`px-4 sm:px-6 py-2.5 rounded-full text-sm font-semibold transition-all ${
                active === p.id
                  ? "bg-[var(--oz-gold)] text-white"
                  : "bg-white/10 text-white/70 hover:bg-white/20"
              }`}
            >
              {p.name}
            </button>
          ))}
        </div>

        <div className="max-w-2xl mx-auto bg-white/5 border border-white/10 rounded-[1.75rem] p-8 md:p-10">
          <div className="grid grid-cols-2 gap-6 mb-8">
            <div className="text-center">
              <div className="text-xs uppercase tracking-wider text-white/50 mb-2">Investissement</div>
              <div className="font-serif text-3xl sm:text-4xl text-white">{fmt(pack.price)}</div>
            </div>
            <div className="text-center">
              <div className="text-xs uppercase tracking-wider text-white/50 mb-2">Produits</div>
              <div className="font-serif text-3xl sm:text-4xl text-white">{pack.products}</div>
            </div>
          </div>

          <div className="bg-[var(--oz-gold)]/15 border border-[var(--oz-gold)]/30 rounded-2xl p-6 text-center">
            <div className="text-xs uppercase tracking-wider text-[var(--oz-gold)] mb-2">
              Exemple de chiffre d'affaires potentiel
            </div>
            <div data-testid="potential-value" className="font-serif text-4xl sm:text-5xl text-white">
              jusqu'à {fmt(potential)}
            </div>
          </div>

          <p className="mt-5 text-[11px] leading-relaxed text-white/45 italic text-center">
            Exemple indicatif basé sur les conditions de revente applicables. Il ne constitue pas une
            garantie de revenus. Les résultats réels dépendent des ventes effectivement réalisées, des
            prix pratiqués et des conditions commerciales.
          </p>

          <button
            data-testid="potential-cta"
            onClick={() => addItem(pack.id)}
            className="mt-7 w-full inline-flex items-center justify-center px-6 py-4 rounded-full bg-white text-[var(--oz-dark)] font-semibold text-sm tracking-wide hover:bg-[var(--oz-bg)] transition-colors"
          >
            CHOISIR CE PACK
          </button>
        </div>
      </div>
    </section>
  );
};
